import React, {FC, useEffect, useRef, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import axiosInstance from './api/axiosInstance'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const PegadaianDetailBooking: FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const kodeReservasi = queryParams.get('kode_reservasi')

  // State untuk menyimpan data API
  const [detail, setDetail] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  const ticketRef = useRef<HTMLDivElement>(null) // Ref untuk area tiket
  const [isExporting, setIsExporting] = useState(false) // State loading saat export

  const hendleSearchBooking = () => {
    navigate('/mudik-bersama/pegadaian/check-booking')
  }

  // Fetch Data dari API
  useEffect(() => {
    const fetchDetailBooking = async () => {
      if (!kodeReservasi || kodeReservasi === '-') return

      try {
        setLoading(true)
        // Sesuaikan dengan base_url Anda
        const response = await axiosInstance.get(
          `/rsvm/api/rsvm-booking/v1/search-by-code?kode_reservasi=${kodeReservasi}`
        )

        if (response.data.statusCode === 200) {
          setDetail(response.data.data)
        }
      } catch (error) {
        console.error('Error fetching booking detail:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchDetailBooking()
  }, [kodeReservasi])

  if (loading) {
    return (
      <div
        className='d-flex justify-content-center align-items-center'
        style={{minHeight: '100vh', backgroundColor: '#037556'}}
      >
        <div className='spinner-border text-light' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    )
  }

  if (!detail) {
    return (
      <div
        className='text-center p-20 text-white'
        style={{backgroundColor: '#037556', minHeight: '100vh'}}
      >
        <p>Data tidak ditemukan</p>
        <button onClick={hendleSearchBooking} className='btn btn-light btn-sm'>
          Kembali
        </button>
      </div>
    )
  }

  const isBoarded = detail.statusBooking === 'BOARDED'

  const handleDownloadPDF = async () => {
    if (!ticketRef.current) return

    try {
      setIsExporting(true)
      await new Promise((resolve) => setTimeout(resolve, 100))

      const element = ticketRef.current
      const canvas = await html2canvas(element, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: '#037556',
        scrollY: -window.scrollY,
      })

      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [canvas.width, canvas.height],
      })

      pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height)
      pdf.save(`E-Ticket-Mudik-${detail.code}.pdf`)
    } catch (error) {
      console.error('Gagal generate PDF:', error)
    } finally {
      // 3. Munculkan kembali tombolnya
      setIsExporting(false)
    }
  }

  return (
    <div className='container-xxl p-0' style={{minHeight: '100vh'}}>
      <div className='row justify-content-center mx-0'>
        <div
          className='col-12 col-md-8 col-lg-5 p-0 pb-10 mx-auto'
          style={{backgroundColor: '#037556'}}
          ref={ticketRef}
        >
          {/* Header & Back Button */}
          <div className='p-5 d-flex align-items-center mb-2'>
            <button
              onClick={hendleSearchBooking}
              className={`btn btn-icon me-2 ${isExporting ? 'd-none' : ''}`}
            >
              <i className='bi bi-arrow-left fs-1 text-white'></i>
            </button>
            <h3 className='fw-bolder mb-0 text-white'>E-Ticket Mudik</h3>
          </div>

          {/* MAIN TICKET CARD */}
          <div className='mx-5 position-relative mb-10'>
            <div
              className='bg-white overflow-hidden shadow-lg'
              style={{borderRadius: '25px', position: 'relative'}}
            >
              {/* Top Section: Logos & QR */}
              <div className='p-8 text-center'>
                <div className='d-flex justify-content-between align-items-center mb-8 px-2'>
                  <img
                    src={toAbsoluteUrl('/img/pegadaian-logo-bl.png')}
                    alt='pegadaian'
                    style={{height: '25px'}}
                  />
                  <h4 className='fw-bolder mb-0'>
                    <span style={{color: '#72BF44'}}>Mudik</span>{' '}
                    <span style={{color: '#BFD730'}}>Bersama</span>
                  </h4>
                </div>

                <div className='mb-4'>
                  {isBoarded ? (
                    /* TAMPILAN JIKA SUDAH BOARDED */
                    <div className='py-5 d-flex flex-column align-items-center'>
                      <div className='mb-3' style={{position: 'relative'}}>
                        <i
                          className='bi bi-patch-check-fill text-success'
                          style={{fontSize: '5rem'}}
                        ></i>
                      </div>
                      <h3 className='fw-bolder text-success mb-1'>SUDAH BOARDING</h3>
                      <p className='text-muted small'>Selamat menikmati perjalanan Anda!</p>
                    </div>
                  ) : (
                    /* TAMPILAN QR CODE JIKA BELUM BOARDED */
                    <>
                      <img
                        src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${detail.code}`}
                        alt='QR Code'
                        className='img-fluid shadow-sm p-2 bg-white rounded'
                        style={{width: '180px'}}
                      />
                      <div className='mt-4 text-muted small fw-bold'>
                        Scan QR Code untuk Boarding
                      </div>
                    </>
                  )}
                </div>

                <div className='text-center mb-8'>
                  <div className='text-muted small'>
                    Kode Reservasi : <span className='fw-bolder text-dark'>{kodeReservasi}</span>
                  </div>
                  <div className='text-muted' style={{fontSize: '10px'}}>
                    Disetujui : {detail.approveTime ?? '-'}
                  </div>
                </div>
              </div>

              {/* TICKET DIVIDER (Dashed Line with Side Circles) */}
              <div className='position-relative py-2'>
                <div
                  className='position-absolute top-50 start-0 translate-middle-y'
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '0 50% 50% 0',
                    marginLeft: '-15px',
                    backgroundColor: '#037556',
                  }}
                ></div>
                <div
                  className='position-absolute top-50 end-0 translate-middle-y'
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '50% 0 0 50%',
                    marginRight: '-15px',
                    backgroundColor: '#037556',
                  }}
                ></div>
                <div
                  className='mx-8 border-bottom border-secondary border-2'
                  style={{borderStyle: 'dashed !important'}}
                ></div>
              </div>

              {/* Bottom Section: Details */}
              <div className='p-8 pt-6'>
                {/* Route Graphic */}
                <div className='d-flex justify-content-between align-items-center mb-6'>
                  <div className='text-start'>
                    <div className='text-muted' style={{fontSize: '10px'}}>
                      Kota Asal
                    </div>
                    <div className='fw-bolder fs-4'>{detail.origin}</div>
                  </div>
                  <div
                    className='flex-grow-1 mx-4 position-relative'
                    style={{height: '2px', borderBottom: '2px dotted #037556'}}
                  ></div>
                  <div className='text-end'>
                    <div className='text-muted' style={{fontSize: '10px'}}>
                      Kota Tujuan
                    </div>
                    <div className='fw-bolder fs-4'>{detail.destination}</div>
                  </div>
                </div>

                <div className='text-center mb-8'>
                  <span className='fw-bold text-muted text-uppercase'>STATUS : </span>
                  <span className='fw-bolder text-success ms-2'>CONFIRM</span>
                </div>

                <div className='mb-8'>
                  <div className='text-muted small mb-3 border-bottom pb-1'>
                    Daftar Penumpang ({detail.passengers?.length || 0})
                  </div>
                  {detail.passengers?.map((p: any, idx: number) => (
                    <div
                      key={idx}
                      className='d-flex justify-content-between align-items-start mb-3'
                    >
                      <div>
                        <div className='fw-bolder text-dark'>{p.nama}</div>
                        <div className='text-muted' style={{fontSize: '11px'}}>
                          {p.nik}
                        </div>
                      </div>
                      {p.relation && (
                        <span className='badge badge-light-dark fw-bold' style={{fontSize: '10px'}}>
                          {p.relation}
                        </span>
                      )}
                    </div>
                  ))}
                </div>

                {/* Info Grid */}
                <div className='row g-5 mb-6'>
                  <div className='col-6'>
                    <div className='text-muted small'>Tanggal Keberangkatan</div>
                    <div className='fw-bolder'>{detail.schDate || 'Akan Diinfokan'}</div>
                  </div>
                  <div className='col-6 text-end'>
                    <div className='text-muted small'>Jam Keberangkatan</div>
                    <div className='fw-bolder'>{detail.sta || 'Akan Diinfokan'}</div>
                  </div>
                  <div className='col-12'>
                    <div className='text-muted small'>Nomor Polisi Bus</div>
                    <div className='fw-bolder fs-5'>{detail.nopol || '-'}</div>
                  </div>
                  <div className='col-12'>
                    <div className='text-muted small'>Lokasi Keberangkatan</div>
                    <div className='fw-bold small lh-base text-dark'>
                      {detail.originAddress || '-'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!isBoarded && !isExporting && (
            <div className='col-12 col-md-8 col-lg-5 px-5 mt-n5 mb-10 mx-auto'>
              <div className='d-flex gap-3'>
                <button
                  onClick={handleDownloadPDF}
                  disabled={isExporting}
                  className='btn btn-outline-white text-white border-white flex-grow-1 py-4 fw-bold'
                  style={{borderRadius: '40px'}}
                >
                  {isExporting ? (
                    <span className='spinner-border spinner-border-sm me-2'></span>
                  ) : (
                    <i className='bi bi-download me-2'></i>
                  )}
                  Simpan E-Ticket (PDF)
                </button>
              </div>
            </div>
          )}

          {isBoarded && !isExporting && (
            <div className='px-5 mb-10 text-center text-white-50 small italic'>
              <p>
                <i className='bi bi-info-circle me-1'></i> Perjalanan telah dimulai. E-Ticket tidak
                tersedia untuk diunduh.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PegadaianDetailBooking
